import React from 'react';
import { useTranslation } from 'react-i18next';

const MenuTypeSelector = ({ menuTypes, selectedMenuTypeId, onChange, disabled = false }) => {
  const { t } = useTranslation();
  
  console.log(`[DEBUG-MenuTypeSelector] Rendering with menuTypes:`, menuTypes);
  console.log(`[DEBUG-MenuTypeSelector] Selected ID: ${selectedMenuTypeId}`);

  if (!menuTypes || menuTypes.length === 0) {
    return <div className="text-gray-600 italic">{t('menu.noMenuTypes')}</div>;
  }
  
  return (
    <div className="relative inline-block">
      <select
        className={`block appearance-none bg-white text-lg border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
        value={selectedMenuTypeId || ''}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label={t('menu.selectMenuType')}
        disabled={disabled}
      >
        {menuTypes.map((menuType) => (
          <option key={menuType.id} value={menuType.id}>
            {menuType.translated_name || menuType.name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  );
};

export default MenuTypeSelector; 